export function generateId() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const bytes = new Uint8Array(8);
    crypto.getRandomValues(bytes);
    let result = '';
    for (let i = 0; i < bytes.length; i++) {
        result += chars[bytes[i] % chars.length];
    }
    return result;
}
